import { useEffect, useState } from "react"
import { isTransferOrCrypto } from "../../../lib/utils"
import {
	OutboundCrypto,
	Price,
	TableOrder,
	TableOrderArs,
	TableOrderCrypto,
} from "../../tables/transactions-table/data/types"

import SlidingCard from "../../ui/sliding-card"
import ExpiredPaymentModalBody from "./body/ExpiredPaymentModalBody"
import PendingPaymentModalBody from "./body/PendingPaymentModalBody"
import SuccessPaymentModalBody from "./body/SuccessPaymentModalBody"
import PaymentStatusRow from "./header/PaymentStatusRow"
import React from "react"

export interface Paymentcommission {
	commission?: Price
	commissionInRequestedCurrency?: Price
	commissionTax?: {
		amount: string
		taxes: {
			tax_rate: number
			tax_amount: number
			tax_type: string
		}[]
	}
	percent?: number
}

interface PaymentModalProps {
	open: boolean
	onClose: () => void
	payment: TableOrder
	onPaymentUpdate: (payment: TableOrder) => void
}

const PaymentModal = React.memo(function PaymentModal({
	open,
	onClose,
	payment: initialPayment,
	onPaymentUpdate,
}: PaymentModalProps) {
	const [currentPayment, setCurrentPayment] = useState(initialPayment)

	useEffect(() => {
		setCurrentPayment(initialPayment)
	}, [initialPayment.id])

	const handlePaymentUpdate = (updatedPayment: TableOrder) => {
		setCurrentPayment(updatedPayment)
		onPaymentUpdate(updatedPayment)
	}

	useEffect(() => {
		if (!open) {
			setCurrentPayment(initialPayment)
		}
	}, [open, initialPayment])

	return (
		<SlidingCard
			open={open}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
			side={"right"}
		>
			<div>
				<PaymentStatusRow
					status={currentPayment.status}
					payment={currentPayment}
					onPaymentUpdate={handlePaymentUpdate}
				/>
				{renderModalBody(currentPayment)}
			</div>
		</SlidingCard>
	)
})

function renderModalBody(payment: TableOrder) {
	let variant = isTransferOrCrypto(payment.payment_options) ?? "transfer"
	switch (payment.status) {
		case "SUCCESS":
		case "OVERPAID":
		case "UNDERPAID":
		case "INBOUND":
			return variant === "crypto" ? (
				<SuccessPaymentModalBody
					payment={payment as TableOrderCrypto}
					variant={variant}
				/>
			) : (
				<SuccessPaymentModalBody
					payment={payment as TableOrderArs}
					variant={variant}
				/>
			)
		case "PENDING":
			return variant === "crypto" ? (
				<PendingPaymentModalBody
					payment={payment as TableOrderCrypto}
					variant={variant}
				/>
			) : (
				<PendingPaymentModalBody
					payment={payment as TableOrderArs}
					variant={variant}
				/>
			)
		case "EXPIRED":
			return variant === "crypto" ? (
				<ExpiredPaymentModalBody
					payment={payment as TableOrderCrypto}
					variant={variant}
				/>
			) : (
				<ExpiredPaymentModalBody
					payment={payment as TableOrderArs}
					variant={variant}
				/>
			)
		default:
			break
	}
}

export default PaymentModal
